module.exports = __webpack_public_path__ + "img/1_030.e05f1248.jpg";